import { sel } from "../../academy/selectors";
import { TutorialDefinition } from "../types";

/**
 * Academy "Your style" lesson: report templates. Started from the lesson page
 * in a new tab; never auto-started. Runs on the officer's own Report
 * Preferences page. Nobody has to have a template yet: the first step covers
 * both cases, and the later steps point at the three template sections, which
 * are always on the page.
 */
const tour: TutorialDefinition = {
  id: "report-templates",
  version: "1.0.0",
  releasedAt: "2026-10-29T00:00:00.000Z",
  category: "onboarding",
  title: "Report templates",
  description: "Build a template with a header, writing instructions, and a footer.",
  triggerRoute: /^\/preferences$/,
  startRoute: "/preferences",
  lessonId: "report-templates",
  autoStart: false,
  steps: [
    {
      target: sel("templateManager"),
      waitFor: sel("templateManager"),
      waitTimeoutMs: 10000,
      title: "Your templates",
      content:
        "Templates live at the bottom of Report Preferences. Click New Template and name it, for example DUI. If you have none yet, fill in the sections below and your first save creates one.",
      disableBeacon: true,
      placement: "top",
    },
    {
      target: sel("templateHeader"),
      waitFor: sel("templateHeader"),
      title: "Custom Header",
      content:
        "Boilerplate that opens every report of this type. Click Insert AI Placeholder / Instruction to add a field like {{Case Number}}, which becomes a bracketed blank in the draft.",
      disableBeacon: true,
      placement: "top",
    },
    {
      target: sel("templateBody"),
      waitFor: sel("templateBody"),
      title: "Narrative Writing Instructions",
      content: "Tell the AI how to structure the body: sections, order, and what to emphasize. Put structure here, and facts in your dictation.",
      disableBeacon: true,
      placement: "top",
    },
    {
      target: sel("templateFooter"),
      waitFor: sel("templateFooter"),
      title: "Custom Footer",
      content: "The closing block for every report of this type.",
      disableBeacon: true,
      placement: "top",
    },
    {
      target: sel("preferencesSave"),
      waitFor: sel("preferencesSave"),
      title: "Save",
      content: "Click Save Preferences to save the template along with your other preferences.",
      disableBeacon: true,
      placement: "top",
    },
    {
      target: sel("templateActions"),
      waitFor: sel("templateActions"),
      title: "Set as default",
      content:
        "Open the gear menu to Rename, Duplicate, Delete, or choose Set as default, which pre-selects this template in Report Settings on every upload.",
      disableBeacon: true,
      placement: "left",
    },
  ],
};

export default tour;
